<template>
  <div class="navbar">
    <!-- <hamburger id="hamburger-container"
     :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" /> -->

    <h3 class="navbar-title">
      厂商品牌概况
    </h3>

    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />

    <div class="right-menu" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import Hamburger from './hamburger';
import Breadcrumb from "./breadcrumb";

export default {
  name: "Navbar",
  components: {
    // Hamburger,
    Breadcrumb
  },
  computed: {
    ...mapGetters(["sidebar"])
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    }
  }
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 48px;
  overflow: hidden;
  position: relative;
  background: transparent;

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .navbar-title {
    font-weight: 600;
    font-size: 18px;
    margin-bottom: 10px;
  }
}
</style>
